import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { courseRunDemandList, courseRunList } from '../store/action/course';
import Loader from '../../components/Loader';
import CourseRunList from '../../components/CourseRunList';
import qs from 'query-string';
import { Button, OverlayTrigger, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TableCellText from '../../components/TableCellText';
import { setCourseRunDemandsStatus } from '../store/action/CourseAction';
import { getCourseCreateButton } from '../../utils/PermissionManager';
import { ActionComponent } from './CourseRunDemands';
import Modal from 'react-bootstrap/Modal';
import { DENY } from '../../utils/CourseDemandStatus';
import Tooltip from 'react-bootstrap/Tooltip';

function CourseList({ history }) {
  let { search, pathname } = history.location;
  const qps = qs.parse(search);
  const [queryParams, setQueryParams] = useState({
    courseDemandPage: 1,
    coursePage: 1,
    ...qps,
  });

  const [showStatusMessageModal, setShowStatusMessageModal] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');

  let listOfCourseDemands = useSelector(state => state.courseNew.demand.list);
  let listOfCourses = useSelector(state => state.courseNew.original.list);

  const { permissions, selectedRole, selectedOrg } = useSelector(state => state.permission);

  let isRenderedCourseDemands = listOfCourseDemands.data && !listOfCourseDemands.isLoading;
  let isRenderedCourses = listOfCourses.data && !listOfCourses.isLoading;
  let dispatch = useDispatch();

  const handlePageChange = (page, name) => {
    setQueryParams({ ...queryParams, [name]: page });
  };

  let handleStateClick = text => {
    setShowStatusMessageModal(true);
    setStatusMessage(text);
  };

  const coursesColumn = [
    {
      Header: 'نام دوره',
      accessor: 'name',
      colName: 'name',
      disableFilters: true,
      Cell: ({ row }) => {
        let { title } = row.original;
        return (
          <TableCellText
            text={
              <Link className={'ml-1'} to={`/course-run-demands/${row.original.id}`}>
                {title}
              </Link>
            }
          />
        );
      },
    },
    {
      Header: 'توضیح کوتاه دوره',
      accessor: 'short_description',
      colName: 'short_description',
      disableFilters: true,
      Cell: ({ row }) => <TableCellText text={row.original.short_description} />,
    },
    {
      Header: 'وضعیت درخواست',
      accessor: 'translated_status',
      colName: 'translated_status',
      disableFilters: true,
      Cell: ({ row }) => {
        let { is_draft, translated_status } = row.original;
        return <TableCellText text={is_draft ? 'پیش نویس' : translated_status} />;
      },
    },
    {
      Header: 'عملیات',
      accessor: 'status',
      Cell: ({ row }) => {
        return (
          <>
            {row.original.status !== DENY ? (
              <a className={'ml-1'} href={`https://courses.darsup.org/courses/${row.original.course_run_key}/course/`}>
                <Button variant={'outline-secondary'} size={'sm'}>
                  ادامه در LMS
                </Button>
              </a>
            ) : (
              <div />
            )}
            {row.original.status !== DENY ? (
              <a className={'ml-1'} href={`https://studio.darsup.org/course/${row.original.course_run_key}`}>
                <Button variant={'outline-secondary'} size={'sm'}>
                  ادامه در studio
                </Button>
              </a>
            ) : (
              <div />
            )}

            {row.original.status === DENY ? (
              <a className={'ml-1'} onClick={() => handleStateClick(row.original.message)}>
                <Button variant={'outline-danger'} size={'sm'}>
                  دلیل رد درخواست
                </Button>
              </a>
            ) : (
              <span />
            )}
          </>
        );
      },
    },
  ];

  const coursesRequestColumn = [
    {
      Header: 'شماره دوره',
      accessor: 'number',
      colName: 'number',
      disableFilters: true,
      Cell: ({ row }) => {
        let { number } = row.original;
        if (row.original.is_draft) return <TableCellText text={number} />;
        return (
          <TableCellText
            text={
              <Link style={{ textDecoration: 'underline' }} to={`/course-run-demands/${row.original.id}`}>
                {number}
              </Link>
            }
          />
        );
      },
    },
    {
      Header: 'اجرای دوره',
      accessor: 'run',
      colName: 'run',
      disableFilters: true,
      Cell: ({ row }) => {
        let { run } = row.original;
        return <TableCellText text={run} />;
      },
    },
    {
      Header: 'نام دوره',
      accessor: 'name',
      colName: 'name',
      disableFilters: true,
      Cell: ({ row }) => {
        let { title } = row.original;
        return <TableCellText text={title} />;
      },
    },
    {
      Header: 'وضعیت درخواست',
      accessor: 'translated_status',
      colName: 'translated_status',
      disableFilters: true,
      Cell: ({ row }) => {
        let { is_draft, translated_status } = row.original;
        return <TableCellText text={is_draft ? 'پیش نویس' : translated_status} />;
      },
    },
    {
      Header: 'فعالیت‌ها',
      accessor: 'actions',
      colName: 'actions',
      disableFilters: true,
      Cell: ({ row }) => {
        let { id, is_draft } = row.original;
        return (
          <>
            {is_draft ? (
              <TableCellText
                text={
                  <TableCellText
                    text={
                      <Link to={`/courses/${id}`}>
                        <Button>
                          <i className="fas fa-pen" />
                          ویرایش
                        </Button>
                      </Link>
                    }
                  />
                }
              />
            ) : ['owner', 'course_creator'].includes(selectedRole.name) ? (
              <ActionComponent
                showlink={true}
                id={row.original.id}
                courseStatus={row.original.status}
                handleChangeDemandStatusClick={(status, errorReason) => {
                  dispatch(
                    setCourseRunDemandsStatus(selectedRole.name, row.original.id, status, refreshLists, errorReason)
                  );
                }}
                callback={getCourseRunDemandList}
              />
            ) : (
              ' - '
            )}
          </>
        );
      },
    },
  ];

  function refreshLists() {
    getCourseRunDemandList();
    getCourseList();
  }

  function getCourseRunDemandList() {
    let paramsAPI = {};
    let paramsRouter = {};

    paramsAPI['page'] = queryParams.courseDemandPage;
    if (queryParams.courseDemandPage > 1) paramsRouter['courseDemandPage'] = queryParams.courseDemandPage;
    if (queryParams.coursePage > 1) paramsRouter['coursePage'] = queryParams.coursePage;

    let paramsString = qs.stringify(paramsRouter);
    paramsString = !!paramsString ? `?${paramsString}` : '';
    history.push(`${pathname}${paramsString}`);

    dispatch(courseRunDemandList(paramsAPI, selectedRole.name));
    /* eslint-disable-next-line */
  }

  useEffect(() => {
    getCourseRunDemandList();
  }, [queryParams.courseDemandPage]);

  function getCourseList() {
    let paramsAPI = {};
    let paramsRouter = {};

    console.log('queryParams:', queryParams);

    paramsAPI['page'] = queryParams.coursePage;
    if (queryParams.coursePage > 1) paramsRouter['coursePage'] = queryParams.coursePage;
    if (queryParams.courseDemandPage > 1) paramsRouter['courseDemandPage'] = queryParams.courseDemandPage;

    let paramsString = qs.stringify(paramsRouter);
    paramsString = !!paramsString ? `?${paramsString}` : '';
    history.push(`${pathname}${paramsString}`);

    dispatch(courseRunList(paramsAPI, selectedRole.name));
  }

  useEffect(() => {
    getCourseList();
    /* eslint-disable-next-line */
  }, [queryParams.coursePage, selectedRole, selectedOrg]);

  return (
    <>
      <div className="kt-portlet p-3">
        <div className="kt-portlet__body pt-0">
          {/*<PermissionChecker roles={[ALL_ROLES.instructor, ALL_ROLES.courseCreator]}>*/}
          {getCourseCreateButton(selectedRole)}
          {/*</PermissionChecker>*/}
          {isRenderedCourseDemands ? (
            <CourseRunList
              columns={coursesRequestColumn}
              courseRunList={listOfCourseDemands}
              count={listOfCourseDemands.count}
              onPageChange={handlePageChange}
              pageParamName={'courseDemandPage'}
              currentPage={parseInt(queryParams.courseDemandPage)}
              title={'درخواست‌های ساخت دوره'}
              hasEdit
            />
          ) : (
            <div className={'text-center'}>
              <Spinner animation={'border'} variant={'primary'} />
            </div>
          )}

          {isRenderedCourses ? (
            <CourseRunList
              columns={coursesColumn}
              courseRunList={listOfCourses}
              count={listOfCourses.count}
              onPageChange={handlePageChange}
              pageParamName={'coursePage'}
              currentPage={parseInt(queryParams.coursePage)}
              title={'لیست دوره ها'}
            />
          ) : (
            <div className={'text-center'}>
              <Spinner animation={'border'} variant={'primary'} />
            </div>
          )}
        </div>
      </div>
      <Loader visible={listOfCourseDemands.isLoading} />

      <Modal
        show={showStatusMessageModal}
        onHide={() => {
          setShowStatusMessageModal(false);
        }}
        keyboard={false}
        animation={true}
      >
        <Modal.Header>
          <Modal.Title>دلیل رد شدن درخواست</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{statusMessage}</p>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CourseList;
